import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { MonthsDateRangeType } from '@app/core/date-range/enums/months-date-range-type.enum';
import { IDateRange } from '@app/core/date-range/interfaces/date-range.interface';
import { ICombinedMinNoiseChartData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/interfaces/combined-min-noise-chart-data';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export enum FpLoggerNoiseMinNoiseActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  ToggleChartFullscreen = 'ToggleChartFullscreen',
  UpdatePeriod = 'UpdatePeriod',
}

export interface FpLoggerNoiseMinNoiseActionGetData {
  type: FpLoggerNoiseMinNoiseActionType.GetData;
  date: string | null;
  popupMainData: ILdLogger | null;
}

export interface FpLoggerNoiseMinNoiseActionGetDataSuccesses {
  type: FpLoggerNoiseMinNoiseActionType.GetDataSuccesses;
  date: string | null;
  cacheDateRange?: IDateRange | null;
  cacheData?: ICombinedMinNoiseChartData[] | null;
  popupMainData: ILdLogger | null;
  data: ICombinedMinNoiseChartData[] | null;
}

export interface FpLoggerNoiseMinNoiseActionGetDataError {
  type: FpLoggerNoiseMinNoiseActionType.GetDataError;
  date: string | null;
  popupMainData: ILdLogger | null;
  error: IApiBaseErrorResponse;
}

export interface FpLoggerNoiseMinNoiseActionToggleChartFullscreen {
  type: FpLoggerNoiseMinNoiseActionType.ToggleChartFullscreen;
  synchronizeWithPopupId?: string;
}

export interface FpLoggerNoiseMinNoiseActionUpdatePeriod {
  type: FpLoggerNoiseMinNoiseActionType.UpdatePeriod;
  period: MonthsDateRangeType;
}

export type FpLoggerNoiseMinNoiseActions =
  | FpLoggerNoiseMinNoiseActionGetData
  | FpLoggerNoiseMinNoiseActionGetDataSuccesses
  | FpLoggerNoiseMinNoiseActionGetDataError
  | FpLoggerNoiseMinNoiseActionToggleChartFullscreen
  | FpLoggerNoiseMinNoiseActionUpdatePeriod;
